<template>
    <div class="copyrightCert">
        <img class="copyrightCert-img" :src="certImg" alt='版权登记'>
    </div>
</template>

<script>
    export default {
        name: "copyrightCert",
        data() {
            return {
               certImg:''
            }
        },
        created:function () {
            if(this.$route.query.url){
                this.certImg = this.$route.query.url;
            }
        },
        methods: {

        }
    }
</script>

<style scoped>
    .copyrightCert-img{
        width: 846px;
        height: 593px;
        margin: 50px auto;
        display: block;
        background: #f5f5f5;
    }
</style>